"use client";

import { SignOutButton, useAuth } from "@clerk/nextjs";
import { useRouter } from "next/navigation";

import { AppImage } from "@/components/ui/app-image";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  const router = useRouter();
  const { isLoaded, isSignedIn } = useAuth();

  return (
    <div className="bg-background flex min-h-screen items-center justify-center px-6 py-16">
      <div className="bg-card ring-border w-full max-w-md rounded-lg px-8 py-10 text-center ring-1">
        <div className="mb-8 flex items-center justify-center gap-3">
          <AppImage
            alt=""
            className="size-10 rounded-lg"
            height={40}
            priority
            src="/agroproj-logo.svg"
            width={40}
          />
          <p className="text-foreground text-xl font-semibold">AgroProj</p>
        </div>

        <div className="mb-8 flex flex-col gap-2">
          <p className="text-primary text-5xl font-semibold tabular-nums">404</p>
          <h1 className="text-foreground text-xl font-semibold">Página não encontrada</h1>
          <p className="text-muted-foreground">
            A página que você procura não existe ou você não tem permissão para acessá-la.
          </p>
        </div>

        <div className="flex w-full flex-col gap-3">
          <Button className="w-full" onClick={() => router.push("/")} size="lg">
            Voltar ao início
          </Button>
          {isLoaded && isSignedIn ? (
            <SignOutButton>
              <Button className="w-full" size="lg" variant="ghost">
                Sair
              </Button>
            </SignOutButton>
          ) : null}
        </div>
      </div>
    </div>
  );
}
